import useApiClient from './api';

const usePromptService = () => {
  const apiClient = useApiClient();

  const getAllPrompts = async (includeDeleted = false) => {
    try {
      const response = await apiClient.get('/management/prompts', {
        params: { includeDeleted: includeDeleted.toString() }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching prompts:', error);
      throw error;
    }
  };

  const getPromptById = async (id) => {
    try {
      const response = await apiClient.get(`/management/prompts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching prompt:', error);
      throw error;
    }
  };

  const getPromptByName = async (name) => {
    try {
      const response = await apiClient.get(`/management/prompts/name/${name}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching prompt by name:', error);
      throw error;
    }
  };

  const createPrompt = async (promptData) => {
    try {
      const response = await apiClient.post('/management/prompts', promptData);
      return response.data;
    } catch (error) {
      console.error('Error creating prompt:', error);
      throw error;
    }
  };

  const updatePrompt = async (id, promptData) => {
    try {
      const response = await apiClient.put(`/management/prompts/${id}`, promptData);
      return response.data;
    } catch (error) {
      console.error('Error updating prompt:', error);
      throw error;
    }
  };

  const deletePrompt = async (id) => {
    try {
      const response = await apiClient.delete(`/management/prompts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting prompt:', error);
      throw error;
    }
  };

  const restorePrompt = async (id) => {
    try {
      const response = await apiClient.post(`/management/prompts/${id}/restore`);
      return response.data;
    } catch (error) {
      console.error('Error restoring prompt:', error);
      throw error;
    }
  };

  const getPromptHistory = async (id, page = 1, limit = 20) => {
    try {
      const response = await apiClient.get(`/management/prompts/${id}/history`, {
        params: { page, limit }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching prompt history:', error);
      throw error;
    }
  };

  const initializeDefaultPrompts = async () => {
    try {
      const response = await apiClient.post('/management/prompts/initialize-defaults');
      return response.data;
    } catch (error) {
      console.error('Error initializing default prompts:', error);
      throw error;
    }
  };

  return {
    getAllPrompts,
    getPromptById,
    getPromptByName,
    createPrompt,
    updatePrompt,
    deletePrompt,
    restorePrompt,
    getPromptHistory,
    initializeDefaultPrompts
  };
};

export default usePromptService;